import React, { Component } from "react";
import { FaChevronLeft, FaSteam, FaVoteYea } from "react-icons/fa";
import Button from "../../components/Button";
import { API_BASE_URL, DATE_VOTE_FINISHED } from "../../util/constants";
import { GoogleColorIcon } from "../../components/GoogleColorIcon";
import AuthService from "../../services/auth";

import "./styles.css";

export class Privacy extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userData: null,
    };
  }
  componentDidMount() {
    AuthService.getCurrentUserData().then((response) => {
      const userData = response.data.data;

      this.setState({
        userData,
      });
    });
  }
  render() {
    const { userData } = this.state;
    const now = new Date();
    const nowDate = new Date(now.getTime());
    const voteEndDate = new Date(new Date(DATE_VOTE_FINISHED).getTime());
    return (
      <div className="LogoContainer">
        <div className="Logo">
          <img
            src="https://static.draft5.gg/jovem-do-ano/logo.png"
            width="400"
            alt="Logo"
          />
          {nowDate <= voteEndDate && (
            <>
              <h2 className="Logo__title">Faça login para votar</h2>
              {!userData && (
                <div className="Login__buttons">
                  <a
                    className={["Button", "Google"].join(" ")}
                    href={`${API_BASE_URL}/user/google`}
                  >
                    <GoogleColorIcon width={18} />
                    Fazer login com o Google
                  </a>
                  <a
                    className={["Steam", "Button"].join(" ")}
                    href={`${API_BASE_URL}/user/steam`}
                  >
                    <FaSteam size={18} />
                    Fazer login com a Steam
                  </a>
                </div>
              )}
              {userData && (
                <div className="Login__buttons">
                  <a className={["Vote", "Button"].join(" ")} href={`/players`}>
                    <FaVoteYea size={18} />
                    Ir para votação
                  </a>
                </div>
              )}
            </>
          )}
        </div>
        <div className="RulesContainer">
          <span className="RulesText">
            <h2>TERMOS DE USO</h2>
            <p>
              Coletamos seu nome completo e e-mail para que seja usado em seu
              login e exibição na plataforma do hotsite prêmio do Jovem do Ano
              DRAFT5. Não repassaremos para nenhum parceiro. Ao se inscrever no
              hotsite da votação você concorda integralmente com isso.
            </p>

            <h2>POLÍTICA DE PRIVACIDADE</h2>
            <p>
              A Política de Privacidade estabelece como a DRAFT5 irá utilizar os
              dados pessoais e informações oferecidas pelos seus clientes e
              assinantes.
            </p>
            <p>
              Dados Pessoais: Significa qualquer dado que possa ser utilizado
              para te identificar.
            </p>
            <p>
              Todas as informações dos nossos membros que coletamos em nosso
              site são de uso exclusivo da DRAFT5, sendo utilizadas para:
              prestação de serviços, manter os usuários a par de quaisquer
              atualizações relacionadas ao nosso site, e enviar informações ou
              conteúdo nos quais você possa ter interesse.
            </p>
            <p>
              Também utilizamos essas informações para melhorar continuamente
              nossos serviços, nosso site e a sua experiência. A base de dados
              formada pela DRAFT5 por meio da coleta de informações no site,
              poderá ser compartilhada com nosso grupo de empresas.
            </p>

            <h2>USO DE DADOS</h2>
            <p>
              Nós usamos os seus dados apenas e tão somente na medida das nossas
              necessidades e tratamos os seus dados com toda a segurança. A
              DRAFT5 usa tecnologia de ponta para garantir a segurança de todos
              os dados que usa, especialmente os seus dados. Ao usar os serviços
              da DRAFT5, você está nos autorizando a fazer uso desses dados.
            </p>

            <br />
            <span>
              Para ler o nossos termos e políticas de forma completa, por favor
              acesse:{" "}
              <a href="https://privacy.gamersclub.gg/privacy/" target=" _blank">
                clique aqui
              </a>
            </span>

            <Button
              className="Rules__GoBack"
              onClick={() => {
                this.props.history.goBack();
              }}
            >
              <FaChevronLeft size={12} />
              <span>Voltar</span>
            </Button>
          </span>
        </div>
      </div>
    );
  }
}
